import { View } from 'foundations-components/components/View';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import SidebarPanelBody from 'EmailEditorUI/components/sidebar/SidebarPanelBody';
import { getScrollbarSize } from 'EmailEditorUI/utils/scrollbarSizeUtil';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
const ErrorPanel = () => {
  const sidebarWidth = getScrollbarSize() || 0;
  const width = `${420 + sidebarWidth}px`;
  return /*#__PURE__*/_jsx(View, {
    inlineSize: width,
    minInlineSize: width,
    children: /*#__PURE__*/_jsx(SidebarPanelBody, {
      "data-selenium": "error-panel",
      children: /*#__PURE__*/_jsx(TFlex, {
        align: "center",
        direction: "column",
        children: /*#__PURE__*/_jsx(ErrorMessage, {
          title: I18n.text('codeSplitting.reload.title'),
          illustrationProps: {
            width: '100'
          },
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "codeSplitting.reload.message"
          })
        })
      })
    })
  });
};
export default ErrorPanel;